/** App14 chips use the complete micro role; environment labels alone add wide tracking. */
export const chipBaseClasses =
  'inline-flex items-center whitespace-nowrap select-none shrink-0 rounded-[var(--oq-corner-compact)] px-2 py-1 oq-text-micro';
export const badgeBaseClasses = `${chipBaseClasses} tracking-[var(--oq-letter-spacing-wide)]`;

/** The small control box keeps semantic issue badges aligned with their preserved optical glyphs. */
export const issueBadgeClasses =
  'inline-flex items-center gap-1 h-[var(--oq-control-app-small-height)] px-2 rounded-[var(--oq-corner-compact)] oq-text-micro capitalize whitespace-nowrap';
